import AlertService from '../Services/AlertService';
import DM1Service from '../Services/DM1Service';

export default class AlertAndDMRequestHelper {
  constructor(params) {
    this.alertID = params.alertID;
    this.canbusFilter = params.canbusFilter;
    this.children = params.children;
    this.fmiFilter = params.fmiFilter;
    this.gatewayIdFilter = params.gatewayIdFilter;
    this.limit = params.limit;
    this.order = params.order;
    this.orgID = params.orgID; // for satisfying API auth requiring a param named orgID'
    this.orgIdFilter = params.orgIdFilter; // for filtering by/modifying rules-service table column
    this.page = params.page;
    this.ruleIdFilter = params.ruleIdFilter;
    this.saFilter = params.saFilter;
    this.severityFilter = params.severityFilter;
    this.sort = params.sort;
    this.spnFilter = params.spnFilter;
    this.transitionFilter =
      params.selectedStatus === 'all' ? null : params.selectedStatus;
    this.typeFilter = params.typeFilter;
  }

  fetchAlertMetrics(cancelToken) {
    return new AlertService().fetchAlertByRuleMetrics(this, cancelToken);
  }

  async fetchAlerts(cancelToken) {
    const { Alerts } = await new AlertService().fetchPaginatedAlertsByRule(
      this,
      cancelToken
    );
    return Alerts;
  }

  async clearAlert(cancelToken) {
    const { Alert } = await new AlertService().clearAlert(this, cancelToken);
    return Alert;
  }

  fetchDM1Metrics(cancelToken) {
    return new DM1Service().getDM1FaultsCount(this, cancelToken);
  }

  async fetchDM1s(cancelToken) {
    const { DmAlerts } = await new DM1Service().getDM1Faults(this, cancelToken);
    return DmAlerts;
  }
}
